import { render, staticRenderFns } from "./GameHeader.vue?vue&type=template&id=26007afd&scoped=true&"
import script from "./GameHeader.vue?vue&type=script&lang=js&"
export * from "./GameHeader.vue?vue&type=script&lang=js&"
import style0 from "./GameHeader.vue?vue&type=style&index=0&id=26007afd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26007afd",
  null
  
)

export default component.exports